import React from 'react';
import { MenuItem } from 'primereact/menuitem';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Button } from 'primereact/button';

export interface SphereTypeOption {
  name: string;
  avatar: string;
  type: string;
}

interface SphereMenuProps {
  sphereSearch: string;
  setSphereSearch: React.Dispatch<React.SetStateAction<string>>;
  loading: boolean;
  sphereOptions: SphereTypeOption[];
  selectedOptions: SphereTypeOption[];
  onOptionToggle: (e: React.MouseEvent | React.KeyboardEvent, option: SphereTypeOption) => void;
  onClear: (e: React.MouseEvent) => void;
}

const SphereMenu = ({
  sphereSearch,
  setSphereSearch,
  loading,
  sphereOptions,
  selectedOptions,
  onOptionToggle,
  onClear,
}: SphereMenuProps): MenuItem[] => {
  const filteredOptions = sphereOptions
    .filter((opt) =>
      opt.name.toLowerCase().includes(sphereSearch.toLowerCase())
    )
    .sort((a, b) => {
      const nameA = a.name || a.type || ''
      const nameB = b.name || b.type || ''
      return nameA.localeCompare(nameB)
    });

  return [
    {
      template: () => (
        <div className="p-2 flex align-items-center">
          <input
            list="sphereTypeOptions"
            placeholder="Search types…"
            value={sphereSearch}
            onChange={(e) => setSphereSearch(e.target.value)}
            onMouseDown={(e) => e.stopPropagation()}
            className="w-full"
            aria-label="Search types"
          />
          <datalist id="sphereTypeOptions">
            {sphereOptions.map((opt) => (
              <option key={opt.type} value={opt.name} />
            ))}
          </datalist>
          {sphereSearch && (
            <button
              type="button"
              className="pi pi-times ml-2 cursor-pointer"
              onClick={(e) => {
                e.stopPropagation();
                setSphereSearch('');
              }}
              aria-label="Clear search"
            />
          )}
        </div>
      ),
    },
    ...(loading
      ? [
          {
            template: () => (
              <div className="p-2 flex justify-content-center">
                <ProgressSpinner
                  style={{ width: '20px', height: '20px', margin: '10px 0 0 10px' }}
                  strokeWidth="4"
                />
              </div>
            ),
          },
        ]
      : []),
    ...filteredOptions.map((opt) => ({
      template: () => (
        <button
          className={`sphere-menu-item flex align-items-center ${
            selectedOptions.some((o) => o.type === opt.type) ? 'selected' : ''
          }`}
          tabIndex={0}
          onClick={(e) => onOptionToggle(e, opt)}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              onOptionToggle(e, opt);
            }
          }}
        >
          <span className={`avatar ${opt.avatar}`} />
          <span className="option-label ml-2">{opt.name}</span>
        </button>
      ),
    })),
    {
      template: () => (
        <div className="p-2 flex justify-content-end">
          <Button
            label="Clear"
            className="p-button clear-button p-button-sm"
            onClick={onClear}
          />
        </div>
      ),
    },
  ];
};
export default SphereMenu;